// extracted by mini-css-extract-plugin
export default {"wrapper":"iXsFkRU7","center":"FEWWktrI","right":"FXNTlsIy","interactive":"O6dWAwYM","content":"GAvxZ7xR","spoiler":"ynSPM0hu","left":"DSH91Ntx","fixedWidth":"CBhjF9XS"};